import common from "~/assets/messages/en/common.json";
import error from "~/assets/messages/en/error.json";

/** En resources. */
const enResources = {
  // App
  messages: {
    common,
    error,
  },
};

export default enResources;
